const DEFAULT_COLUMNS = [
  {
    Header: "Linea",
    id: "key ",
    type: "number",
    accessor: "Linea",
  },
  {
    Header: "Nombre",
    id: "Response",
    type: "Text",
    accessor: "Name",
  },
  {
    Header: "Precio Unitario",
    type: "number",
    accessor: "PrecioUnitario",
    maxWidth: "100px",
  },
  {
    Header: "Cantidad",
    type: "number",
    accessor: "Quantity",
  },
  {
    Header: "Total",
    type: "number",
    accessor: "Monto",
    maxWidth: "100px",
  },
];

export default DEFAULT_COLUMNS;
